<template>
  <MglMap
    :accessToken="accessToken"
    :mapStyle.sync="mapStyle"
    :attributionControl="false"
    :center="coordinates"
    :zoom="17"
    @load="onMapLoad"
  >
    <MglAttributionControl />
    <MglNavigationControl position="top-right" />
    <MglGeolocateControl position="top-right" />
    <MglScaleControl />
    <MglMarker :coordinates.sync="coordinates" color="red" />
  </MglMap>
</template>

<script>
import Mapbox from "mapbox-gl";
import {
  MglMap,
  MglMarker,
  MglNavigationControl,
  MglGeolocateControl
} from "vue-mapbox";
import "mapbox-gl/dist/mapbox-gl.css";

export default {
  components: {
    MglMap,
    MglMarker,
    MglNavigationControl,
    MglGeolocateControl
  },
  props: {
    coordinates: Array
  },
  data() {
    return {
      accessToken:
        "pk.eyJ1IjoiYmVybmFzdiIsImEiOiJjazkwMmxzNWUwMWswM2xxZGQ1amdncnh0In0.ux-97u5DV19BlQfb2Qzcig", // your access token. Needed if you using Mapbox maps
      mapStyle: "mapbox://styles/mapbox/streets-v11"
    };
  },

  created() {
    // We need to set mapbox-gl library here in order to use it in template
    this.mapbox = Mapbox;
  },
  methods: {
    async onMapLoad(event) {
      // Here we cathing 'load' map event
      const asyncActions = event.component.actions;

      await asyncActions.flyTo({
        //long lat
        center: this.coordinates
      });
    }
  }
};
</script>
